// removed by extract-text-webpack-plugin
module.exports = {"MenuItem":"_1nVgA6jbLUQPRy5eUyNaws","MainMenu":"_38TyWfR7Wv7fZi4moM4tyV","example":"B-DK22m6kBHDBkPuQlONX"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/RightPanel/style.css
// module id = 2458
// module chunks = 0